"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mask_1 = __importDefault(require("../../../../../utils/mask"));
const getInputMaskState = ({ input, mask, typeahead = false, event, definitions, }) => {
    const { complete, maskedValue, unmaskedValue } = (0, mask_1.default)(input || '', mask, { typeahead, definitions });
    return { complete, value: unmaskedValue, viewValue: maskedValue, event };
};
exports.default = getInputMaskState;
